<ion-content class="ion-no-padding">
  <div class="lead-form model-container" >
    <div class="model-content ion-padding-horizontal py-1">
      <div class="row h-100">
        <div class="col h-100 p-0">
          <div class="input-container h-100">
            <div class="h-100">
              <textarea name="" class="textarea h-100 p-2" id="" placeholder="Add Points Here" [(ngModel)]="points" autofocus></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Save button -->
    <div class="model-footer ion-padding-horizontal bg-light-gray">
      <ion-button class="unfilled-blue-btn" (click)="closeModal()">Close</ion-button>
      <ion-button class="filled-blue-btn" (click)="submit()">Submit</ion-button>
    </div>
  </div>
</ion-content>